import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-richiesta-socio-golf',
  templateUrl: './richiesta-socio-golf.component.html',
  styleUrls: ['./richiesta-socio-golf.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class RichiestaSocioGolfComponent implements OnInit, OnDestroy {
  public richiestaInviata: boolean;
  sub: Subscription;
  firstRun: boolean;

  constructor(private app: AppComponent,
    private route: ActivatedRoute,) {
    this.richiestaInviata = false;
    this.sub = new Subscription();
    this.firstRun = false;
  }

  ngOnInit(): void {
    this.sub = this.app.initialized.subscribe(async (init) => {
      if (init) {  //  && !this.firstRun

      }
    });
  }

  ngOnDestroy(): void {

  }

  invia() {
    this.richiestaInviata = true;
  }


}
